import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import { updateVote } from "../../../services/voteServices";
import Button from "../../../components/Button/Button";
import { toast } from "react-toastify";

const EditVoteModal = ({ isOpen, onClose, vote, refreshList }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    start_time: "",
    end_time: "",
    type: "vote",
    is_active: true,
  });

  useEffect(() => {
    if (vote) {
      setFormData({
        title: vote.title || "",
        description: vote.description || "",
        start_time: vote.start_time?.slice(0, 10) || "",
        end_time: vote.end_time?.slice(0, 10) || "",
        type: vote.type || "vote",
        is_active: vote.is_active ?? true,
      });
    }
  }, [vote]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateVote(vote.id, formData);
      refreshList();
      onClose();
      toast.success("Vote modifié avec succès");
    } catch (error) {
      console.error("Erreur modification vote :", error);
      toast.error("Erreur lors de la modification");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-white p-4 rounded-lg shadow-lg max-w-md w-[90%]">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          Modifier le Vote / Sondage
        </h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="title"
            placeholder="Titre"
            value={formData.title}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />
          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
            className="textarea textarea-bordered w-full mb-3"
          />
          <input
            type="date"
            name="start_time"
            value={formData.start_time}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />
          <input
            type="date"
            name="end_time"
            value={formData.end_time}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            className="select select-bordered w-full mb-3"
          >
            <option value="vote">Vote</option>
            <option value="sondage">Sondage</option>
          </select>
          <label className="flex items-center gap-2 mb-3">
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              className="checkbox"
            />
            Actif
          </label>
          <div className="flex justify-center space-x-2 mt-4">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              type="button"
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditVoteModal;
